import type { RouteObject } from 'react-router-dom';

/** Formations : chaque page est un chunk chargé à la demande (hls.js uniquement dans la page de leçon). */
export const courseRoutes: RouteObject[] = [
  { path: 'apprendre', lazy: () => import('./CatalogPage').then((m) => ({ Component: m.CatalogPage })) },
  { path: 'apprendre/mes-formations', lazy: () => import('./MyCoursesPage').then((m) => ({ Component: m.MyCoursesPage })) },
  { path: 'apprendre/lecon/:lessonId', lazy: () => import('./LessonPage').then((m) => ({ Component: m.LessonPage })) },
  { path: 'apprendre/direct/:liveId', lazy: () => import('./LivePage').then((m) => ({ Component: m.LivePage })) },
  {
    path: 'apprendre/professeur',
    lazy: () => import('./teacher/TeacherLayout').then((m) => ({ Component: m.TeacherLayout })),
    children: [
      { index: true, lazy: () => import('./teacher/TeacherCoursesPage').then((m) => ({ Component: m.TeacherCoursesPage })) },
      { path: 'cours/:courseId', lazy: () => import('./teacher/CourseEditorPage').then((m) => ({ Component: m.CourseEditorPage })) },
      { path: 'cours/:courseId/lecon/:lessonId', lazy: () => import('./teacher/LessonEditorPage').then((m) => ({ Component: m.LessonEditorPage })) },
      { path: 'directs', lazy: () => import('./teacher/LivesPanel').then((m) => ({ Component: m.TeacherLivesPage })) },
      { path: 'revenus', lazy: () => import('./teacher/EarningsPage').then((m) => ({ Component: m.EarningsPage })) },
    ],
  },
  { path: 'apprendre/:slug', lazy: () => import('./CourseDetailPage').then((m) => ({ Component: m.CourseDetailPage })) },
  { path: 'attestations/:code', lazy: () => import('./CertificateVerifyPage').then((m) => ({ Component: m.CertificateVerifyPage })) },
  { path: 'admin/formations', lazy: () => import('./admin/AdminFormationsPage').then((m) => ({ Component: m.AdminFormationsPage })) },
];
